import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { formatDecimalForDisplay } from "../../../utils/formatting-utils"

const axisColour = "#666666"

const Segment = styled.div`
  width: 100%;
  text-align: center;
`
const BottomSegment = styled.div`
  display: block;
  border-color: ${axisColour};
  border-style: solid;
  border-top-width: 1px;
  border-left-width: 1px;
  border-right-width: ${props => (props.scaleNumber === 10 ? "1px" : "0px")};
  border-bottom: none;
  font-weight: bold;
  border-collapse: collapse;
`

const TopSegment = styled.div`
  display: block;
  font-weight: bold;
  color: ${axisColour};
`

function NpsScaleSegment({ peoplePercentage, hexColor, scaleNumber }) {
  const percentageToDisplay = formatDecimalForDisplay(parseFloat(peoplePercentage), 1)
  return (
    <Segment>
      <TopSegment>{percentageToDisplay}%</TopSegment>
      <BottomSegment style={{ color: hexColor }} scaleNumber={scaleNumber}>
        {scaleNumber}
      </BottomSegment>
    </Segment>
  )
}

NpsScaleSegment.propTypes = {
  hexColor: PropTypes.string.isRequired,
  scaleNumber: PropTypes.number.isRequired,
  peoplePercentage: PropTypes.string.isRequired,
}

export default NpsScaleSegment



// WEBPACK FOOTER //
// ./src/components/widgets/CustomNPS/NpsScaleSegment.jsx